import utils from 'utils'
import InvAccountManagementConfig from './fieldConfig'
import accountModal from './view/accountModal.html'

export default class InvAccountManagementListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, sweetalert, initSortService, selectManualSolution, $location) {
        $scope.datePickerConfig = {
            autoclose: true,
            minView: 'year', // 选择日期后，不会再跳转去选择时分秒
            startView: 'year',
            language: 'zh-CN',
            format: 'yyyy-mm',
            forceParse: 0,
            pickTime: false,
            pickerPosition: 'bottom-right',
        }
        const currentDate = new Date()
        const date30DaysAgo = new Date(currentDate)
        date30DaysAgo.setDate(currentDate.getDate() - 30)

        $scope.param = {
            selectedOrgs: [],
            selectedCompanystatus: [],
            selectedRequeststatus: [],
        }
        $scope.treeConfig = {
            isCheckall: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }

        $scope.treeConfigCompanystatus = {
            inputName: 'enumName',
            isCheckall: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
            data: {
                simpleData: {
                    enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                    idKey: 'enumCode', //节点数据中保存唯一标识的属性名称 默认值id
                    pIdKey: 'parentOrgId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                    rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                },
                key: {
                    name: 'enumName',
                },
            },
        }
        $scope.selectedRows = []
        $scope.customizedConfig = InvAccountManagementConfig
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                orgIdList: [],
                companyEntryStatusList: [],
                entryRequestStatusList: [],
                paymentMonthStr: ``,
                invoiceDateStart: date30DaysAgo.toISOString().split('T')[0],
                invoiceDateEnd: currentDate.toISOString().split('T')[0],
            },
        }
        const pathParam = $location.path().replace(/\//g, '-')
        $scope.orderMap = initSortService(pathParam)
        $scope.queryParam.orderMap = $scope.orderMap.wrap
        $scope.orgList = []
        const initDict = () => {
            const dictTypeArr = ['ivat_inv_add_type', 'entry_purpose_status', 'invoice_source', 'pool_inv_type', 'interface_source_system', 'ivat_invoice_status', 'interface_source_system', 'company_entry_status', 'department_no', 'entry_request_status', 'red_confirm_invoice_source','ivat_source_app_id']
            return httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                $scope.dictData = res1.data.value
                $scope.param.selectedCompanystatus = $scope.dictData.entry_purpose_status.concat([])
                $scope.param.selectedCompanystatus.forEach((ele) => {
                    ele.checked = true
                })
                $scope.param.selectedRequeststatus = $scope.dictData.entry_request_status.concat([])
                $scope.param.selectedRequeststatus.forEach((ele) => {
                    ele.checked = true
                })
            })
        }
        const getAllTaxBureau = () => {
            // 获取所有主管税局信息
            return httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.dictDataProvince = res.data.value
            })
        }
        $scope.reset = function () {
            initDict()
            $scope.queryParam.param = {
                orgIdList: $scope.queryParam.param.orgIdList,
                paymentMonthStr: ``,
                invoiceDateStart: date30DaysAgo.toISOString().split('T')[0],
                invoiceDateEnd: currentDate.toISOString().split('T')[0],
            }
        }
        //查询功能，和表头排序功能
        const queryList = () => {
            if ($scope.queryParam.param.paymentMonthStr) $scope.queryParam.param.paymentMonth = $scope.queryParam.param.paymentMonthStr.replace('-', '')
            $scope.queryParam.param.companyEntryStatusList = $scope.param.selectedCompanystatus.map((ele) => {
                return ele.enumCode
            })
            $scope.queryParam.param.entryRequestStatusList = $scope.param.selectedRequeststatus.map((ele) => {
                return ele.enumCode
            })
            httpRequest.post_ivatInvoiceEntry($scope.queryParam).then((res) => {
                let result = res.data.value
                $scope.dataList = result.list
                $scope.totalItems = result.total
                $scope.queryParam.pageNum = result.pageNum
                $scope.selectedRows = []
            })
        }
        const getOrgList = () => {
            return httpRequest.get_getUserOrgList().then((res) => {
                console.log(1)
                $scope.orgList = res.data.value
                for (let index = 0; index < $scope.orgList.length; index++) {
                    const element = $scope.orgList[index]
                    if (element.orgId === $scope.userInfo.org.orgId) {
                        $scope.param.selectedOrgs = [element]
                        element.checked = true
                        $scope.queryParam.param.orgIdList = [element.orgId]
                    }
                }
            })
        }
        $scope.init = async function () {
            await getOrgList()
            await initDict()
            await getAllTaxBureau()
            queryList()
        }
        $scope.init()
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = $scope.orderMap.wrap
            queryList()
        }
        $scope.search = function () {
            queryList()
        }
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.$watch(
            'param.selectedOrgs',
            (newVal, oldVal) => {
                $scope.queryParam.param.orgIdList.length = 0
                newVal.forEach((el) => {
                    $scope.queryParam.param.orgIdList.push(el.orgId)
                })
            },
            true
        )
        $scope.invEntryOperationConfig = {
            btnText: '发票入账操作',
            options: [
                {
                    text: '入账查询',
                    hasPermit: 'account_inquiry',
                    handler() {
                        $scope.accountProcessing('query')
                    },
                },
                {
                    text: '入账保存',
                    hasPermit: 'entry_save',
                    handler() {
                        if (!entrySaveCheck()) return
                        $scope.accountProcessing('save')
                    },
                },
                {
                    text: '入账调整',
                    hasPermit: 'accounting_adjustment',
                    handler() {
                        if (!accountAdjustmentCheck()) return
                        $scope.accountProcessing('adjust')
                    },
                },
            ],
        }
        function entrySaveCheck() {
            if (!$scope.selectedRows.length) {
                logger.logError('请选择数据')
                return false
            }
            const custCreditCodes = new Set($scope.selectedRows.map((el) => el.custCreditCode))
            const entryStatuses = new Set($scope.selectedRows.map((el) => el.entryPurposeStatus))
            if (custCreditCodes.size > 1) {
                logger.logError('所选发票的购方税号不一致，请按购方税号筛选查询。')
                return false
            }
            if (entryStatuses.size > 1 || !entryStatuses.has('01')) {
                logger.logError('所选发票的入账状态不为未入账，请重新选择未入账的发票入账保存。')
                return false
            }
            return true
        }

        function accountAdjustmentCheck() {
            if (!$scope.selectedRows.length) {
                logger.logError('请选择数据')
                return false
            }
            const custCreditCodes = new Set($scope.selectedRows.map((el) => el.custCreditCode))
            const hasStatus01 = $scope.selectedRows.some((el) => el.entryPurposeStatus === '01')
            if (custCreditCodes.size > 1) {
                logger.logError('所选发票的购方税号不一致，请按购方税号筛选查询。')
                return false
            }
            if (hasStatus01) {
                logger.logError('发票入账用途存在未入账，不支持入账调整，请检查。')
                return false
            }
            return true
        }

        $scope.accountProcessing = async (type) => {

             let flag =  await selectManualSolution.getResult()
            if(!flag) return
            $uibModal
                .open({
                    template: accountModal,
                    backdrop: 'static',
                    controller: 'accountModalCtrl',
                    openedClass: 'mod-modal mod-modal-lg mod-modal-big',
                    resolve: {
                        modalData() {
                            return { type, dictData: $scope.dictData, orgList: $scope.orgList, selectedRows: $scope.selectedRows }
                        },
                    },
                })
                .result.then((data) => {
                    queryList()
                })
        }
        $scope.exportExel = function exportExel() {
            httpRequest.post_exportInvoiceEntryAsyn($scope.queryParam.param).then((res) => {
                logger.logSuccess(res.data.message)
            })
            // let _url = `${host.etcloudIvatApp}tax4/ivatInvoiceEntry/exportInvoiceEntryAsyn?accessToken=${localStorage.getItem('id_token')}`
            // utils.file_download(
            //     _url,
            //     $scope.queryParam.param,
            //     '', //type
            //     'POST',
            //     'blob',
            //     '',
            //     false
            // )
        }
    }
}
InvAccountManagementListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService', 'selectManualSolution', '$location']



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/InvAccountManagement/list.js